import React from "react";

const DataActRequestService = React.lazy(() => import("./dataAct.view"));

export { DataActRequestService };
